import { useQuery } from '@apollo/client/react/hooks/useQuery'
import { useBuyingSessionGroupName } from '@modules/wholesale/buyingGroupSummary/graphql/hooks'
import { useBuyingSession } from '@modules/wholesale/buyingSessionCollection/graphql/hooks'
import { stores } from '@stores'
import { GET_BUYING_SESSION_COLLECTION } from '../graphql/getBuyingSessionCollection'

/**
 * Hook for buying session collection
 */
export const useBuyingSessionCollection = variables => {
  return useQuery(GET_BUYING_SESSION_COLLECTION, {
    variables,
    skip: Object.keys(variables || {}).length === 0
  })
}

/**
 *
 * @param isWholesale
 * Hook to get the buyingsessionGroup Name on the basis of wholsale or retail request.
 */
export const useBuyingSessionGroupNameForChannel = (
  isWholesale: boolean,
  skip = false
): string => {
  const {
    nav: {
      buyingSession,
      buyingSessionGroupId,
      params: { podium: podiumId }
    }
  } = stores
  const { data: groupNameRes } = useBuyingSessionGroupName(
    skip || !isWholesale ? undefined : buyingSessionGroupId
  )
  const { data: buyingSessionRes } = useBuyingSession(
    skip || !isWholesale ? undefined : buyingSession
  )
  const { data: buyingSessionCollectionRes } = useBuyingSessionCollection(
    skip || isWholesale ? undefined : { collectionId: podiumId }
  )
  return isWholesale
    ? buyingSessionGroupId
      ? groupNameRes?.getVIPBuyingSessionGroup.Name
      : buyingSessionRes?.getVIPBuyingSession.Name
    : buyingSessionCollectionRes?.buyingSessionCollection.name
}
